import { render } from "./AdminRecoveryForm.vue?vue&type=template&id=37819b4f"
import script from "./AdminRecoveryForm.vue?vue&type=script&lang=js"
export * from "./AdminRecoveryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__